module.exports = __webpack_public_path__ + "static/12-cf1273707191a38f243d17c82f0682b2.jpg";